var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00712 14.6667C1.00712 14.2986 1.30559 14.0001 1.67378 14.0001H8.34045C8.70864 14.0001 9.00712 14.2986 9.00712 14.6667C9.00712 15.0349 8.70864 15.3334 8.34045 15.3334H1.67378C1.30559 15.3334 1.00712 15.0349 1.00712 14.6667Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00712 8.66675C5.37531 8.66675 5.67378 8.96522 5.67378 9.33341V14.6667C5.67378 15.0349 5.37531 15.3334 5.00712 15.3334C4.63893 15.3334 4.34045 15.0349 4.34045 14.6667V9.33341C4.34045 8.96522 4.63893 8.66675 5.00712 8.66675Z",
    fill: "#1B1C1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80129 0.941297C1.92675 0.768803 2.12716 0.666748 2.34045 0.666748H7.67378C7.88707 0.666748 8.08748 0.7688 8.21293 0.941291C9.38712 2.55574 10.2073 5.0816 9.28422 7.18442C8.56697 8.81851 6.9275 10.0001 5.00712 10.0001C3.16213 10.0001 1.56853 8.92934 0.811364 7.37842C-0.234084 5.23667 0.589488 2.60751 1.80129 0.941297ZM2.00953 6.79347C1.31555 5.37171 1.75192 3.44391 2.69076 2.00008L2.00953 6.79347ZM2.69076 2.00008H7.3235C8.23103 3.39533 8.67694 5.2507 8.06334 6.64847C7.54559 7.82805 6.36633 8.66675 5.00712 8.66675C3.69098 8.66675 2.55171 7.904 2.00953 6.79347",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.26ccdeff4647092023d94b7ff39d041e.svg";
export { ForwardRef as ReactComponent };